
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  height: 100%;
}

.idb-document-card {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

@media (min-width: 1280px) {

  .idb-document-card {
    padding: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .idb-document-card {
    padding: 1rem;
  }
}

.idb-document-card{
  word-break:break-word;
}

.idb-document-card-bg-gray {
  background-color: var(--gray-professional-lighten-4);
}

.idb-document-card-bg-white {
  background-color: var(--neutral-white);
}

.header {
  display: flex;
  gap:0.5rem;
}

idb-heading {
  color: var(--blue-responsible-main);
}

.header a {
  margin-bottom: -1rem;
  overflow-wrap: break-word;
  color: var(--blue-responsible-darken-2);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

@media (min-width: 480px) {

  .header a {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.header a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.header .icon {
  padding-top: 0.25rem;
}

::slotted([slot='icon']) {
  color: var(--green-guarantee-lighten-2);
}

.titles {
  flex-wrap: wrap;
}

@media (min-width: 480px) {

  .titles {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

::slotted([slot='heading']) {
  max-height: 4.2em;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--blue-responsible-main);
}

@media (min-width: 768px) {

  ::slotted([slot='heading']) {
    height: 4.2em;
  }
}

::slotted([slot='heading']){
  position:relative;
  z-index:2;
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
  text-overflow:ellipsis;
  text-wrap:wrap;
}

::slotted([slot='subtitle']) {
  font-weight: var(--fw-semibold);
  text-transform: uppercase;
  color: var(--gray-professional-lighten-1);
}

.detail {
  color: var(--gray-professional-lighten-1);
  font-size:0.8rem;
}

.footer {
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
}

.footer .icon {
  font-weight: var(--fw-bold);
  color: var(--blue-responsible-main);
}

.footer .right-content {
  display: flex;
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
  color: var(--blue-responsible-main);
}

a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.tooltip {
  display: flex;
}

.tooltip-text {
  padding: 1rem;
}

@media (min-width: 1280px) {

  .tooltip-text {
    padding: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .tooltip-text {
    padding: 1rem;
  }
}

.tooltip .tooltip-text {
  visibility: hidden;
  margin-left: 1rem;
  margin-right: 3rem;
  border-radius: 0.5rem;
  background-color: var(--neutral-white);
  padding: 0.5rem;
  color: var(--blue-responsible-darken-2);
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  text-align:center;
  position:absolute;
  z-index:4;
  top:100%;
  overflow:visible;
  opacity:0;
  transition:opacity 0.3s;
}

.tooltip .tooltip-text::before{
  content:'';
  position:absolute;
  bottom:100%;
  left:50%;
  margin-left:-5px;
  border-width:7px;
  border-style:solid;
  border-color:transparent transparent var(--neutral-white) transparent;
  transition:opacity 0.3s;
}

.idb-document-card:hover .tooltip-text {
  visibility: hidden;
}

@media (min-width: 480px) {

  .idb-document-card:hover .tooltip-text {
    visibility: visible;
  }
}

.idb-document-card:hover .tooltip-text{
  opacity:1;
}

.tooltip:before{
  opacity:0;
  transition:0.3s;
}

.tooltip:hover:before{
  opacity:1;
}
`;